import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CopilotFreComponent } from './copilot-fre.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        CopilotFreComponent
    ],
    entryComponents: [
        CopilotFreComponent
    ],
    exports: [ CopilotFreComponent ]
})
export class CopilotFreModule {
}
